module.exports = __webpack_public_path__ + "img/yyys-fuzb1.1156dc0b.webp";